import { Base } from '@studiometa/js-toolkit';
import Post from './Post.js';

/**
 * Instagram
 */
export default class Instagram extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'Instagram',
    components: {
      Post,
    },
    options: {
      url: {
        type: String,
        default: '',
      },
    },
  };

  /**
   * Mount component
   */
  mounted() {
    fetch(this.$options.url)
      .then((response) => response.json())
      .then((response) => {
        const results = response.data ?? [];
        results.forEach((element, index) => {
          this.$children.Post[index]?.setInstaData(
            element.link,
            element.images.standard_resolution.url,
          );
        });
        this.refreshSlider(results.length);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  /**
   * Refresh the sibling Swiper once the feed is loaded :
   * - remove the slots that received no post (feed shorter than the number of
   *   slots) so the slider doesn't loop over empty squares ;
   * - re-clone the loop slides, which Swiper builds at init — i.e. before the
   *   images are injected asynchronously — so the cloned slides aren't blank.
   * @param {number} filledCount Number of slots actually filled by the feed.
   */
  refreshSlider(filledCount) {
    const swiper = this.$el.querySelector('.swiper')?.swiper;
    if (!swiper) {
      return;
    }

    const total = this.$children.Post.length;
    if (filledCount < total) {
      const emptyIndexes = [];
      for (let index = filledCount; index < total; index += 1) {
        emptyIndexes.push(index);
      }
      swiper.removeSlide(emptyIndexes);
    }

    if (swiper.params.loop) {
      swiper.loopDestroy();
      swiper.loopCreate();
    }

    swiper.update();
  }
}
